export const LANGUAGES = [
  "Hindi", "English", "Bengali", "Assamese", "Tamil", "Telugu", "Marathi",
  "Gujarati", "Kannada", "Malayalam", "Punjabi", "Odia", "Urdu", "Konkani",
  "Nepali", "Sanskrit", "Spanish", "French", "German", "Japanese", "Korean", "Mandarin",
];

export const INTERESTS = [
  "Music", "Movies", "Sports", "Cricket", "Football", "Gaming", "Reading",
  "Travel", "Photography", "Fitness", "Cooking", "Art", "Technology", "Business",
  "Dancing", "Yoga", "Fashion", "Writing", "Hiking", "Foodie",
];
